import { FC } from 'react';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import { dragEndToMove, useBinomDragSensors } from '@/features/flow-optimizer/tabs/standard/binom/workspace/list/use-binom-drag-sensors';
import type { DraftGateway, DraftPoolRow } from '../../../../drop-generator.types';
import type { GatewayOp } from '../../state/gateway-draft';
import { GatewayChip } from './GatewayChip';

const Item: FC<{ row: DraftPoolRow; index: number }> = ({ row, index }) => {
  const { setNodeRef, setActivatorNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({ id: row.id });
  return <span ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition, zIndex: isDragging ? 1 : undefined }}>
    <button ref={setActivatorNodeRef} type="button" {...attributes} {...listeners} aria-label={`Move gateway ${String.fromCharCode(65 + index)} (#${row.routeId})`} className="flex touch-none cursor-grab items-center gap-1 rounded border border-border bg-background p-1 focus-visible:ring-2 focus-visible:ring-primary">
      <GripVertical className="h-3 w-3" /><GatewayChip index={index} /><span className="text-xs">#{row.routeId}</span>
    </button>
  </span>;
};

export const ManualRotation: FC<{ gateway: DraftGateway; order: number[]; onOp: (op: GatewayOp) => void }> = ({ gateway, order, onOp }) => {
  const sensors = useBinomDragSensors();
  return <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={(event) => {
    const move = dragEndToMove(event, gateway.pool.map((r) => r.id));
    if (move) onOp({ kind: 'poolMove', ...move });
  }}><SortableContext items={order.map((i) => gateway.pool[i].id)} strategy={rectSortingStrategy}>
    <div className="flex flex-wrap gap-2" aria-label="Manual gateway rotation">{order.map((i) => <Item key={gateway.pool[i].id} row={gateway.pool[i]} index={i} />)}</div>
  </SortableContext></DndContext>;
};
